import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../api-base.service';

@Injectable({
    providedIn: 'root'
})
export class TimelineReportApiService {

    constructor(
        private apiBaseService: ApiBaseService,
    ) { }

    // Get all individuals data
    getIndividualAllEvents(individualId: number): Observable<any> {
        return this.apiBaseService.get<any>("/api/timelinereport/" + individualId, null, null, null)
    }
}